import Header from "./header/Header"
import Cuando from "./secciones/Cuando";
import Donde from "./secciones/Donde";
import Entradas from "./secciones/Entradas";
import Liquidacion from "./secciones/Liquidacion";
import Permisos from "./secciones/Permisos";
import Que from "./secciones/Que";
import MapaTeatroPreview from "./secciones/MapaTeatroPreview";

const Evento = ({
  setLabel,
  label,
  labels,
  id,
  locale,
  fecha,
  setFecha,
  search,
  categorias,
  form,
  setForm,
  setValidation,
  validation,
  onClick,
  onChange,
  modal,
  setModal,
  me,
  loading,
  queRef,
  materialPendiente,
  setMaterialPendiente,
  tieneSiteMap,
  puedeAgregarSiteMap
}) => {


  // Verificar si hay mapa de teatro cargado
  const tieneMapaTeatro = form?.mapa_teatro_id?.[0] && form?.mapa_teatro_data?.[0];

  const set_label = (label) => {
    switch (label) {
      /* ¿Qué? */
      case 0: {
        return <Que
          ref={queRef}
          setForm={setForm}
          form={form}
          setValidation={setValidation}
          validation={validation}
          categorias={categorias}
          materialPendiente={materialPendiente}
          setMaterialPendiente={setMaterialPendiente}
        />
      } break;
      /* ¿Donde? */
      case 1: {
        return <Donde
          setForm={setForm}
          form={form}
          setValidation={setValidation}
          validation={validation}
          search={search}
          tieneSiteMap={tieneSiteMap}
          puedeAgregarSiteMap={puedeAgregarSiteMap}
        />
      } break;
      /* ¿Cuando? */
      case 2: {
        return <Cuando
          setForm={setForm}
          form={form}
          setValidation={setValidation}
          validation={validation}
          locale={locale}
          fecha={fecha}
          setFecha={setFecha}
        />
      } break;
      /* Entradas */
      case 3: {
        return <Entradas
          setForm={setForm}
          tieneSiteMap={tieneSiteMap}
          form={form}
          setValidation={setValidation}
          validation={validation}
          modal={modal}
          setModal={setModal}
        />
      } break;
      /* Mapa de Teatro - Solo si hay mapa cargado */
      case 4: {
        if (tieneMapaTeatro) {
          return (
            <div className="container-md">
              <MapaTeatroPreview mapaData={form.mapa_teatro_data[0]} />
            </div>
          );
        } else {
          // Si no hay mapa, mostrar Liquidación
          return <Liquidacion
            setForm={setForm}
            form={form}
            setValidation={setValidation}
            validation={validation}
            modal={modal}
            setModal={setModal}
          />
        }
      } break;
      /* Liquidacion */
      case 5: {
        if (tieneMapaTeatro) {
          return <Liquidacion
            setForm={setForm}
            form={form}
            setValidation={setValidation}
            validation={validation}
            modal={modal}
            setModal={setModal}
          />
        } else {
          // Si no hay mapa, mostrar Permisos
          return <Permisos
            id={id}
            setForm={setForm}
            form={form}
          />
        }
      } break;
      /* Permisos */
      case 6: {
        return <Permisos
          id={id}
          setForm={setForm}
          form={form}
        />
      } break;
    }
  }

  const pagination = () => {
    if(id){
      return <div></div>
    }

    switch (label) {
      case 0: return <div className="container-md d-flex justify-content-between mt-3">
        <label className="btn btn-dark w-100 ms-2">
          CONTINUAR <i class="bi bi-chevron-right"></i>
          <button className="d-none"
            onClick={() => setLabel(label + 1)}></button>
        </label>
      </div>
      case 1:
      case 2:
      case 3: return <div className="container-md d-flex justify-content-between mt-3"><label className="btn btn-dark w-100 me-2">
      <i class="bi bi-chevron-left"></i> VOLVER
      <button className="d-none"
        onClick={() => setLabel(label - 1)}></button>
    </label>
      <label className="btn btn-dark w-100 ms-2">
        CONTINUAR <i class="bi bi-chevron-right"></i>
        <button className="d-none"
          onClick={() => setLabel(label + 1)}></button>
      </label>
    </div>
      case 4: return <div className="container-md d-flex justify-content-between mt-3"><label className="btn btn-dark w-100 me-2">
      <i class="bi bi-chevron-left"></i> VOLVER
      <button className="d-none"
        onClick={() => setLabel(label - 1)}></button>
    </label>
    </div>

    }
  }
  return (
    <div className="min-vh-100 pb-5">
      <Header
        onClick={onClick}
        labels={labels}
        setLabel={setLabel}
        label={label}
        id={id}
        form={form}
        setForm={setForm}
        me={me}
        loading={loading}
      />
      {set_label(label)}
      {pagination()}
    </div>
  )
}

export default Evento